export interface AppBuildManifest {
  schemaVersion: 1;
  buildNumber: number;
  appVersion: string;
  commit: string;
  builtAt: string;
}

const numericEnvironmentValue = (value: string | undefined): number => {
  const parsed = Number(value || 0);
  return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : 0;
};

/** Identidad inmutable compilada dentro de cada build. */
export const CURRENT_APP_BUILD: AppBuildManifest = {
  schemaVersion: 1,
  buildNumber: numericEnvironmentValue(process.env.REACT_APP_BUILD_NUMBER),
  appVersion: process.env.REACT_APP_BUILD_VERSION || 'development',
  commit: process.env.REACT_APP_BUILD_COMMIT || 'development',
  builtAt: process.env.REACT_APP_BUILD_DATE || ''
};

export const isAppBuildManifest = (value: unknown): value is AppBuildManifest => {
  if (!value || typeof value !== 'object') return false;
  const manifest = value as Partial<AppBuildManifest>;
  return manifest.schemaVersion === 1
    && Number.isSafeInteger(manifest.buildNumber)
    && Number(manifest.buildNumber) > 0
    && typeof manifest.appVersion === 'string'
    && typeof manifest.commit === 'string'
    && typeof manifest.builtAt === 'string';
};
